import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { consts } from '@src/constants/consts';
import { environmentsActions } from '@src/store/reducers/environmentsReducer';
import { MultiUpgradePreValidatePackageDialogData } from './multi-upgrade-prevalidate-package-dialog.data';
import { MultiUpgradePackageDataSource } from './multi-upgrade-package.data-source';

import _ from 'lodash';

@Component({
    selector : 'multi-upgrade-prevalidate-package-dialog',
    template: require('./multi-upgrade-prevalidate-package-dialog.component.html'),
    styles: [require('./multi-upgrade-prevalidate-package-dialog.component.scss')]
})
export class MultiUpgradePreValidatePackageDialogComponent implements OnInit, OnDestroy {
    public delayShowAvailable = true;
    public isCollapsedSelected = true;
    public isCollapsedAvailable = true;
    public selectedPackageType = false;
    public selectedFilterOption: string;
    public filterText: string;
    public filterOptions: any[];
    public availablePackages: MultiUpgradePackageDataSource;
    public showAvailablePackages = false;

    private defaultOrderSelectedPackages = true;
    private packageMap = new Map();

    constructor(
        private dialogRef: MatDialogRef<MultiUpgradePreValidatePackageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MultiUpgradePreValidatePackageDialogData) {
        this.selectedFilterOption = consts.FilterOption.Package_Or_Tag.toString();
        const arrOptions = [];
        for (const x in consts.FilterOption) {
            arrOptions.push({ key: x.replace(new RegExp('_', 'g'), ' '), value: consts.FilterOption[x] });
        }
        this.filterOptions = arrOptions;
    }

    public async ngOnInit() {
        this.data.autoBackupSelected = this.data.autoBackUpItems[0].Key.toString();
        this.data.autoRestoreSelected = this.data.autoRestoreItems[0].Key.toString();

        const filterText = this.filterText ? this.filterText : '';
        this.availablePackages = new MultiUpgradePackageDataSource(
            this.data, filterText, this.selectedFilterOption, this.selectedPackageType);
        await this.availablePackages.reset(filterText, this.selectedFilterOption, this.selectedPackageType);
        this.showAvailablePackages = true;
        this.availablePackages.forEach((elem:any) =>{
            this.packageMap.set(elem.id, this.getTags(elem));
        })

    }

    public ngOnDestroy() {
        this.showAvailablePackages = false;
        this.availablePackages.disconnect();
    }

    public async onSplitChanged() {
        this.ngOnDestroy();
        await this.ngOnInit();
    }

    public onRemovePackage(pack: any, from: any, to: any, reorderRequired: any) {
        if (to === this.data.packages.selectedPackages && to.length === 0) {
            this.defaultOrderSelectedPackages = true;
        }

        if (!this.defaultOrderSelectedPackages && to === this.data.packages.selectedPackages) {
            pack.order = Math.max(...to.map((x: any) => x.order), 0) + 1;
        }

        to.push(pack);
        const index = from.indexOf(pack);
        if (index !== -1) {
            from.splice(index, 1);
        }
        if (reorderRequired === true
            && (this.defaultOrderSelectedPackages || to === this.availablePackages)) {
            this.restoreOrder(true, to);
        }
    }

    public getTags(pack: any) {
        const tag = pack.tags.find((x: any) => x.name); 
        if(tag){
            return tag.name;
        }
        return ''
    }

    public transferAll(from: any, to: any) {
        let i = from.length;
        const reversedFrom = from.reverse();
        while (i--) {
            this.onRemovePackage(reversedFrom[i], reversedFrom, to, false);
        }
        from.splice(0, from.length);
        if (this.defaultOrderSelectedPackages || to === this.availablePackages) {
            this.restoreOrder(true, to);
        }
    }

    public restoreOrder(isForcedDefault: any, packages: any) {
        if (isForcedDefault === true) {
            packages.forEach((x: any) => { x.order = this.availablePackages.defaultSort.find(y => y.id === x.id).order; });
        }
        packages.sort((a: any, b: any) => parseInt(a.order, 10) - parseInt(b.order, 10));
    }

    public async onFilterPackages() {
        const filterText = this.filterText ? this.filterText : '';
        await this.availablePackages.reset(filterText, this.selectedFilterOption, this.selectedPackageType);
        this.showAvailablePackages = true;
    }

    public onSwitchOrder(pack: any, direction: any) {
        this.defaultOrderSelectedPackages = false;
        const packagesSelected = _.orderBy(this.data.packages.selectedPackages, ['order'], ['asc']);
        packagesSelected.forEach((elm: any, index: any) => { elm.order = index; });
        const { 0: nextPack } = direction > 0
            ? _.orderBy(packagesSelected.filter((m: any) => m.order < pack.order), ['order'], ['desc'])
            : _.orderBy(packagesSelected.filter((m: any) => m.order > pack.order), ['order'], ['asc']);

        if (nextPack) {
            const order = pack.order;
            pack.order = nextPack.order;
            nextPack.order = order;
            this.data.packages.selectedPackages = _.orderBy(packagesSelected, ['order'], ['asc']);
        }
    }

    public getPackageTypes() {
        const arrOptions = [];
        for (const x in consts.PackageType) {
            arrOptions.push({ key: x, value: consts.PackageType[x] });
        }
        return arrOptions;
    }

    public async onUpgrade() {
        const packages = this.data.packages.selectedPackages.map((x: any) => ({ packageId: x.id, order: x.order }));
        const packagesToUpgrade = _.orderBy(packages, ['order'], ['asc']);
        await this.data.dispatch({
            type: environmentsActions.UPGRADE_PREVALIDATE_BY_TASK,
            payload: {                       
                type: this.data.title === 'Upgrade' ? 'Upgrade' : 'PreCheck',
                projectId: this.data.project.projectId,
                envId: this.data.environment.id,
                body: {
                    packagesToUpgrade,
                    backupBehavior: this.data.autoBackupSelected === "" ? null : this.data.autoBackupSelected,
                    restoreBehavior: this.data.autoRestoreSelected === "" ? null : this.data.autoRestoreSelected
                }
                
            }
        });
        this.close();
    }

    public close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/multi-upgrade-prevalidate-package-dialog/multi-upgrade-prevalidate-package-dialog.component.ts